import TourPage from "@/components/TourPage";

export default function QueenElizabeth3Day() {
  return (
    <TourPage
      tourId="uganda/queen-elizabeth-3-day"
      title="3-Day Queen Elizabeth National Park Safari"
      duration="3 Days / 2 Nights"
      price="Contact for price"
      image="/leopard.webp"
      description="Experience the remarkable Queen Elizabeth National Park, famous for its tree-climbing lions, diverse wildlife, and stunning crater lakes. This 3-day safari offers game drives, a boat cruise on the Kazinga Channel, and chances to spot various wildlife species."
      itinerary={[
        {
          day: 1,
          title: "Kampala to Queen Elizabeth National Park",
          description: "Journey to Queen Elizabeth National Park through Uganda's scenic landscapes.",
          activities: [
            "Early morning departure from Kampala",
            "Drive through the western Uganda countryside",
            "Arrive at the park in the afternoon",
            "Evening game drive if time permits",
            "Dinner and overnight at the lodge"
          ],
          accommodation: "Mweya Safari Lodge or similar",
          meals: "Lunch, Dinner"
        },
        {
          day: 2,
          title: "Game Drive & Boat Cruise",
          description: "Full day of wildlife viewing and boat safari.",
          activities: [
            "Early morning game drive in search of lions, elephants, and other wildlife",
            "Return to lodge for lunch",
            "Afternoon boat cruise on the Kazinga Channel",
            "Evening game drive",
            "Dinner and overnight"
          ],
          accommodation: "Mweya Safari Lodge or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Morning Game Drive & Return to Kampala",
          description: "Final wildlife viewing and return journey.",
          activities: [
            "Early morning game drive",
            "Breakfast at the lodge",
            "Drive back to Kampala",
            "Stop for lunch en route",
            "Evening arrival in Kampala"
          ],
          meals: "Breakfast, Lunch"
        }
      ]}
      inclusions={[
        "Park entrance fees",
        "Transportation in a 4x4 safari vehicle",
        "English-speaking guide/driver",
        "Boat cruise fees",
        "Game drives as mentioned",
        "Accommodation as per itinerary",
        "Meals as specified",
        "Bottled water"
      ]}
      exclusions={[
        "International flights",
        "Visa fees",
        "Travel insurance",
        "Personal items",
        "Tips and gratuities",
        "Drinks and beverages",
        "Optional activities not mentioned"
      ]}
    />
  );
}
